export function EmptyButton({ buttonText, methodToCall }) {

    return (
        <>
            <button className="w-[140px] md:w-[220px] lg:w-[200px] h-10 border-[1px] border-midnight-color text-midnight-color rounded-md font-bold text-xs md:text-base lg:text-base" onClick={methodToCall}>{buttonText}</button>
        </>
    )
}